<template>
  <div class="container flex-row-space-evenly">
    <div class="image"></div>
    <div class="technique flex-column">
      <div class="flex-row-space-evenly trait-container">
        <div class="trait-bleu"></div><p>Régie</p>
      </div>
      <h2>Assistance technique</h2>
      <p>Nous mettons à votre disposition une</p>
      <p>ou plusieurs ressources selon le besoin</p>
      <p>exprimé pour intervenir sur vos projets.</p>
      <button @click="changeTo('assistance')">En savoir plus</button>
    </div>
    <div class="service flex-column">
      <div class="flex-row-space-evenly trait-container">
        <div class="trait-bleu"></div><p>Forfait</p>
      </div>
      <h2>Centre de service</h2>
      <p>Nous mettons en place une structure dédiée </p>
      <p>à votre projet pour mieux répondre à votre besoin.</p>
      <button @click="changeTo('centre-service')">En savoir plus</button>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
        methods: {
            changeTo(pageName, id) {
                menuBus.$emit('changePage', pageName, id);
            }
        },
        mounted() {
            menuBus.$on('changePage', (pageName, idName) => {
                this.menuShowed = false;
            });
        }
    }
</script>

<style scoped>
  .container {
    height: 700px;
    width: 100%;
  }

  .container > div {
    width: 33%;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .image {
    background: url("../../img/technique_service/photo.png") no-repeat center center;
    background-size: cover;
    width: 34% !important;
  }
  .technique {
    background-color: rgba(159, 168, 189, 0.3);
    position: relative;
  }
  .service {
    background-color: rgba(159, 168, 189, 0.15);
    position: relative;
  }

  .trait-container {
    margin-top: 130px;
  }

  .container > div > * {
    margin-left: 50px;
  }
  .container > div > div > div {
    height: 6px;
    width: 60px;
    background-color: #162139;
    margin-right: 10px;
  }
  .container > div > div > p {
    color: #162139;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 25px;
  }
  h2 {
    color: #162139;
    font-weight: 900;
    width: calc(100% - 100px);
    max-width: 300px;
    text-align: left;
    font-size: 60px;
    line-height: 1.1;
    margin: 0 50px 40px;
  }
  p {
    color: #989cb0;
    text-align: left;
    width: 75%;
    font-size: 20px;
    font-weight: 300;
    line-height: 1.4;
    margin: 0;
  }
  button {
    background-color: #162139;
    border: 2px solid rgba(22, 33, 57, 0);
    color: white;
    padding: 20px 30px;
    text-transform: uppercase;
    margin-top: 50px;
    cursor: pointer;
    font-size: 20px;
    transition: all 0.2s;
    cursor: pointer;

    position: absolute;
    bottom: 80px;
  }
  button:hover {
    border: 2px solid #162139;
    background: none;
    color: #162139;
  }

  /* Tablet */
  @media (max-width: 1200px) {
      h2 {
        font-size: 35px;
        width: calc(100% - 70px);
        max-width: 200px;
      }
      .container > div > div > div {
        height: 4px;
        width: 40px;
      }
      .container > div > div > p {
        font-size: 20px;
      }
      button {
        padding: 20px 30px;
        font-size: 15px;
        bottom: 150px;
      }
      p {
        font-size: 18px;
      }
  }

  /* Mobile */
  @media (max-width: 800px) {
    .container {
      flex-direction: column;
      height: auto;
    }
    .image {
      min-height: 300px !important;
      height: 100vw !important;
      max-height: 400px !important;
      width: 100% !important;
    }
    .container > div {
      width: 100%;
    }
    .technique, .service {
      padding: 20px 0;
      padding-bottom: 40px;
    }
    button {
      position: initial;
    }
    .trait-container {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/TechniqueService.vue